// WebsiteForm.tsx
import React from "react";

import { Business } from "0.Mine/3.Interfaces/business";
import ArgonSnackbar from "components/ArgonSnackbar";

import { useWebsiteFormLogic } from "../../Logic/BasicInfo/Website";
import WebsiteFormUI from "../../UI/WebsiteFormUI";

interface WebsiteFormProps {
  initialValue: string;
  updateBusinessData: (data: Partial<Business>) => void;
}

const WebsiteForm: React.FC<WebsiteFormProps> = ({ initialValue, updateBusinessData }) => {
  const { localValue, handleChange, handleBlur, snackbar } = useWebsiteFormLogic({
    initialValue,
    updateBusinessData,
  });

  return (
    <>
      <WebsiteFormUI localValue={localValue} onChange={handleChange} onBlur={handleBlur} />
      <ArgonSnackbar
        bgWhite={true}
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.content}
        dateTime={snackbar.dateTime}
        open={snackbar.open}
        close={snackbar.onClose}
      />
    </>
  );
};

export default WebsiteForm;
